export const ERROR_CODE_INVALID_AUTH_SESSION = "invalid_auth_session";
export const ERROR_CODE_INVALID_REDIRECT = "invalid_redirect";
export const ERROR_CODE_JWT_DECODE = "decode_jwt";
export const ERROR_CODE_TOKEN_REQUEST_FAILED = "token_request_failed";
export const ERROR_CODE_INVALID_AUTH_CODE = "invalid_redirect";
